import { Avatar, Box, Typography } from "@mui/material";
import { IUser } from "@/redux/models";
import './UsuarioCell.css';

const UsuarioCellData = ({ usuario }: { usuario: IUser }) => {
    return (
        <Box display='flex'>
            <Avatar src={usuario?.fotoPerfil} alt="foto de perfil" sx={{ mr: 1 }} />
            <Box display='flex' flexDirection='column'>
                <Typography variant="body2" alignSelf='center' className='nombre-texto' >
                    {usuario?.nombre} {usuario?.apellido}
                </Typography>
                <Typography variant="body2" alignSelf='center' fontWeight='bold'>
                    {usuario?.company?.nombre}
                </Typography>
            </Box>
        </Box>

    );
}

export default UsuarioCellData;